<template>
    <div></div>
</template>

<script>
import WebOfficeSDK from '@/plugin/web-office-sdk-solution-v2.0.7.es'
import {edit_files} from "@/tools";

export default {
    data() {
        return {
            file_id: '',
        }
    },
    mixins:[],
    computed: {

    },
    created() {
        this.file_id = this.$route.query.id
        this.init()
    },
    mounted() {
        //修改html 标签  overflow: hidden;
        document.getElementsByTagName('html')[0].style.overflow = 'hidden'
    },
    beforeDestroy() {
        //修改html 标签  overflow: hidden;
        document.getElementsByTagName('html')[0].style.overflow = 'auto'
    },
    methods: {
        init() {
            this.$api.apiContent
                .getFileDetail({
                    mid: this.$store.state.userMid,
                    FileId: this.file_id
                })
                .then(res => {
                    let file_type = res.data.fileinfo.label.split(".").pop();
                    let _find =  edit_files.find(f=>{
                        return f.types.includes(file_type.toLowerCase())
                    })
                    const jsSdk = WebOfficeSDK.init({
                        officeType: WebOfficeSDK.OfficeType[_find.officeType],
                        appId: 'SX20250820GOOVMX',
                        fileId: this.file_id,
                        token:this.$store.state.userMid
                    })
                    const ready = async () => {
                        await jsSdk.ready()
                        console.log('api ready')
                    }
                    jsSdk.on('fileOpen', function (data) {
                        ready()
                        console.log('打开成功',data)
                    })
                })
                .catch(e => {
                    console.log(e);
                });

        },
    },
    components: {},
    watch: {}
}
</script>

<style lang="scss" scoped>

</style>